import { RegistryIdName } from '../app/types/accident';

export const normalize = (s?: string) =>
  (s ?? '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim();

const COUNTRY_SYNONYMS: Record<string, string[]> = {
  cesko: ['ceska republika', 'czech republic']
};

export const findCountryId = (
  countryNameFromSeznam: string | undefined,
  countryList: RegistryIdName[] | undefined
): number | undefined => {
  if (!countryNameFromSeznam || !countryList?.length) return;

  const normTarget = normalize(countryNameFromSeznam);

  const exact = countryList.find((c) => normalize(c.name) === normTarget);
  if (exact) return exact.id;

  const synonyms = COUNTRY_SYNONYMS[normTarget];
  if (synonyms?.length) {
    for (const syn of synonyms) {
      const found = countryList.find((c) => normalize(c.name) === syn);
      if (found) return found.id;
    }
  }

  const contains = countryList.find(
    (c) => normalize(c.name).includes(normTarget) || normTarget.includes(normalize(c.name))
  );
  if (contains) return contains.id;

  return;
};
